import React, { Fragment } from 'react';
import BillingEntryMainFormView from '../../../components/account/create/billing_entry/BillingEntryMainFormView';

const BillingEntryCreateListView = () => {
  return (
    <Fragment>
        <BillingEntryMainFormView />
    </Fragment>
  )
}

export default BillingEntryCreateListView